import { EntityMetadataMap } from '@ngrx/data';

export const KE_NAMESPACES_ENTITY_NAME = 'keNamespaces';

const entityMetadata: EntityMetadataMap = {
  [KE_NAMESPACES_ENTITY_NAME]: {
    entityDispatcherOptions: { optimisticAdd: false, optimisticUpdate: false },
  },
};

export const keNamespacesEntityConfig = {
  entityMetadata,
};
